import api from '../../api/api';
import * as ACTIONS from '../actionTypes';
import * as MUTATION from '../mutationTypes';
import {PASS_TAG_FIELD, SLIDES_TYPES} from '@/const';
import {
  componentsMapper,
  PASS_DISPLAY_TYPES,
  prepareBlocksForStore,
  UI_SCOPES,
} from '@/ui_builder/componentsMapper';
import {HOME_TYPES_NAMES} from '@/ui_builder/homeTypes';

export default {
  [ACTIONS.GET_CHANNEL_SETTINGS]: async ({commit}) => {
    commit(
        MUTATION.UPDATE_CHANNEL_SETTINGS,
        await api.channelsApi.get_channel_settings().then(({data}) => data),
    );
  },
  [ACTIONS.GET_CHANNEL_MENU]: async ({commit}) => {
    commit(
        MUTATION.UPDATE_CHANNEL_MENU,
        await api.channelsApi.get_channel_menu().then(({data}) => data),
    );
  },
  [ACTIONS.GET_CHANNEL_SLIDES]: async ({commit}, params) => {
    commit(
        MUTATION.UPDATE_MAIN_CHANNEL_SLIDES,
        await api.channelsApi.get_channel_slides(params).then(({data}) => data),
    );
  },
  [ACTIONS.GET_CHANNEL_PAGES]: async ({commit}) => {
    commit(
        MUTATION.UPDATE_CHANNEL_PAGES,
        await api.channelsApi.get_channel_pages().then(({data}) => data.data),
    );
  },
  [ACTIONS.GET_CHANNEL_PAGE]: async (state, params) => {
    return await api.channelsApi.get_channel_page(params);
  },
  [ACTIONS.GET_COLOR_SETTINGS]: async ({commit}) => {
    commit(
        'UPDATE_CHANNEL_COLORS',
        await api.channelsApi.get_channel_colors().then(({data}) => data),
    );
  },
  [ACTIONS.GET_CHANNEL_STATIC_DATA]: async ({commit}) => {
    const {data} = await api.channelsApi.getChannelStaticData({
      'color-settings[client_interface]': 'web',
      'slides[client_interface]': 'web',
    });
    const DEFAULT_PASS_BUILDER = {
      'key': 'passes',
      'weight': 0,
      'enabled': true,
      'customName': 'handled_passes',
      'type': 'passes',
      'view': PASS_DISPLAY_TYPES.TABLE,
      'group_by': PASS_TAG_FIELD,
      'merge': null,
    };
    
    const {
      'color-settings': colorSettings,
      'events-categories': eventCategories,
      'events-locations': eventLocations,
      faq,
      menu,
      packages,
      pages,
      'participant-groups': participantGroups,
      settings,
      slides,
      subscriptions,
      'participant-group-properties': groupProps,
      static_blocks: staticBlocks,
      attributes,
    } = data;
    try {
      menu && commit(MUTATION.UPDATE_CHANNEL_MENU, menu);
      pages && commit(MUTATION.UPDATE_CHANNEL_PAGES, pages);
      colorSettings && commit(MUTATION.UPDATE_CHANNEL_COLORS, colorSettings);
      settings && commit(MUTATION.UPDATE_CHANNEL_SETTINGS, settings);
      participantGroups &&
      commit(MUTATION.UPDATE_PARTICIPANT_GROUP_LIST, participantGroups);
      participantGroups &&
      commit(MUTATION.UPDATE_GROUP_MENU, participantGroups);
      eventCategories &&
      commit(MUTATION.UPDATE_EVENTS_CATEGORIES, eventCategories);
      eventLocations &&
      commit(MUTATION.UPDATE_EVENTS_LOCATIONS, eventLocations);
      faq && commit(MUTATION.UPDATE_FAQ, faq);
      packages && commit(MUTATION.UPDATE_PACKAGES_LIST, packages);
      subscriptions &&
      commit(MUTATION.UPDATE_SUBSCRIPTIONS_LIST, subscriptions);
      slides && commit(MUTATION.UPDATE_MAIN_CHANNEL_SLIDES, slides);
      groupProps && commit(MUTATION.UPDATE_PARTICIPANTS_PROPS, groupProps);
      staticBlocks && commit(MUTATION.UPDATE_STATIC_BLOCKS, staticBlocks);
      attributes && commit(MUTATION.UPDATE_ATTRIBUTES, attributes);

      if (settings?.ui_builder) {
        const builders = settings?.ui_builder || {};
      
        commit(MUTATION.UPDATE_UI_BLOCKS, {
          homePage: prepareBlocksForStore({
            ui: builders.home_blocks,
            scope: UI_SCOPES.HOME,
          }),
          passesPage: componentsMapper({
            ui: builders.home_blocks.find(({type}) => type === 'passes') || DEFAULT_PASS_BUILDER,
            scope: UI_SCOPES.HOME,
          }),
          scheduleFilters: prepareBlocksForStore({
            ui: builders.schedule_filters,
            scope: UI_SCOPES.SCHEDULE_FILTER,
          }),
        });
      }
      
      const hasTeamOnHome = settings?.ui_builder?.home_blocks?.find(
          ({type}) => (type === HOME_TYPES_NAMES.PARTICIPANTS),
      )?.enabled;

      return hasTeamOnHome || packages?.some(({is_team_pass: team}) => team) ||
          slides?.some(
              ({slidable_type: type}) => type === SLIDES_TYPES.participant);
    } catch (e) {
      console.error('Error in GET_CHANNEL_STATIC_DATA', e);
    }
  },
};
